import { render, staticRenderFns } from "./courseClassContentModal.vue?vue&type=template&id=24d58ff0&"
import script from "./courseClassContentModal.vue?vue&type=script&lang=js&"
export * from "./courseClassContentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports